import type { Provider } from '@angular/core';
import { LocalImportProcessorBridgeService } from '../di/local-import-processor-bridge.service';

export const localImportProcessorProvider: Provider[] = [LocalImportProcessorBridgeService];
